import { ProductCardBody } from "./ProductCardBody/ProductCardBody";
import { ProductCardHeader } from "./ProductCardHeader/ProductCardHeader";
import { ProductCardFooter } from "./ProductCardFooter/ProductCardFooter";
import { SignUpButton } from "./SignUpButton/SignUpButton";
import styles from "./ProductCard.module.scss";
import { EnergyType, PlanDetails, Tariffs } from "@/types/data";
import clsx from "clsx";

interface ProductCardProps {
	plan: Partial<PlanDetails> & Tariffs;
	energy: EnergyType;
	signupUrl: string;
	isCommercial: boolean;
	nmi?: string;
	promoCode?: string;
}

export const ProductCard = ({
	plan,
	energy,
	signupUrl,
	isCommercial,
	nmi,
	promoCode,
}: ProductCardProps) => {
	const isGas = energy === "gas";

	return (
		<div className={styles["product-card"]}>
			<ProductCardHeader
				planName={`${plan.PROD1}`}
				logoURL={`${plan.logoUrl}`}
				imageURL={`${plan.featureImageUrl}`}
				tagline={`${plan.PROD1_TAGLINE}`}
				monthlyEstimate={`${plan.PROD1_EME_MONTH ?? ""}`}
				estimateDescription="inc. GST for a household using 24.5 kWh/day"
				estimateTitle="Monthly estimate"
			/>
			<hr className={styles["product-card__separator"]} />
			<ProductCardBody
				energy={energy}
				list={plan.list ?? []}
				icons={plan.icons ?? []}
			/>

			<hr
				className={clsx(
					styles["product-card__separator"],
					styles["product-card__separator--bottom"],
				)}
			/>
			<ProductCardFooter
				bpid={plan.PROD1_BPID}
				energy={energy}
				plan={plan}
				isCommercial={isCommercial}
				disclaimerText={`${plan.PROD1_DISCLAIMER_TEXT ?? ""}`}
			>
				<SignUpButton
					isGas={isGas}
					signupUrl={signupUrl}
					nmi={nmi}
					promoCode={promoCode}
					productCode={plan.PROD1_TEMPLATE}
					product={plan.PROD1}
				/>
			</ProductCardFooter>
		</div>
	);
};
